import i18n from '@/plugins/i18n';

/* eslint-disable  */
function createCounter() {
  let count = 0;
  return () => {
    ++count;
    return count;
  };
}

const nextCount = createCounter();

const SUCCESS = 'success';
const INFO = 'info';
const ERROR = 'error';

class NotificationService {
  constructor() {
    this.subscribers = {};
    this.timeouts = {};
  }

  /**
   *
   * @param {'created' | 'removed'} event
   * @param {(item) => void} callback
   * @param {Object} param2
   * @param {boolean} param2.once
   */
  addEventListener(event, callback, { once } = {}) {
    if (!this.subscribers[event]) {
      this.subscribers[event] = [];
    }

    this.subscribers[event].push({ cb: callback, once });
  }

  removeEventListener(event, callback) {
    this.subscribers[event] = this.subscribers[event].filter(subscriber => subscriber.cb !== callback);
  }

  /**
   * @param {'created' | 'removed'} event
   * @param {any} item
   */
  dispatchEvent(event, item) {
    this.subscribers[event]?.forEach(subscriber => {
      subscriber.cb(item);

      if (subscriber.once) {
        this.removeEventListener(event, subscriber.cb);
      }
    });
  }

  /**
   * @private
   * @param {string} param0
   * @param {number=} timeout
   */
  push({ message, timeout, file, linkTo, btnNotificationCenter, type = SUCCESS, width, isLoad }) {
    const id = nextCount();
    const item = { message, timeout, type, id, width, isLoad, file, linkTo, btnNotificationCenter };
    this.dispatchEvent('created', item);

    if (timeout) {
      this.timeouts[id] = setTimeout(() => {
        this.remove(item);
      }, timeout);
    }

    return item;
  }

  remove(item) {
    this.dispatchEvent('removed', item);
  }

  updateMessage(item, message) {
    const updatedItem = {
      ...item,
      message,
    };

    if (this.timeouts[item.id] && item.timeout) {
      clearTimeout(this.timeouts[item.id]);

      delete this.timeouts[item.id];

      this.timeouts[item.id] = setTimeout(() => {
        this.remove(item);
      }, item.timeout);
    }

    this.dispatchEvent('updated', { item: updatedItem, id: updatedItem.id });
    return updatedItem;
  }

  /**
   * @param {string} message
   * @param {number=} timeout
   */
  success(message, timeout) {
    return this.push({ message, timeout, type: SUCCESS });
  }

  fileIsReady(message, { file }) {
    return this.push({ message, file, type: SUCCESS });
  }

  failImport(message, { file }) {
    return this.push({ message, file, type: ERROR });
  }

  info(message, { timeout, width, isLoad, linkTo, btnNotificationCenter } = {}) {
    return this.push({ message, timeout, type: INFO, width, isLoad, linkTo, btnNotificationCenter });
  }

  /**
   * @param {string} message
   * @param {number=} timeout
   */
  error(message, timeout) {
    return this.push({ message, timeout, type: ERROR });
  }

  setImportNotification(result, fileName) {
    switch (result.status) {
      case 'SUCCESS':
        if (result.result.hasError) {
          this.failImport(i18n.t('notification.import_fail'), {
            file: {
              url: result.result?.fileName,
              name: fileName,
            },
          });
          break;
        }
        this.success(i18n.t('notification.import_file_ready'), 3000);
        break;
      case 'FAILURE':
        if (!result.result?.fileName) {
          this.error(i18n.t('notification.import_error'));
          break;
        }

        this.failImport(i18n.t('notification.import_fail'), {
          file: {
            url: result.result?.fileName,
            name: fileName,
          },
        });
        break;
      default:
        this.error(i18n.t('notification.import_error'));
        break;
    }
  }

  setExportNotification(result, fileName) {
    switch (result.status) {
      case 'SUCCESS':
        if (result.result.hasError) {
          this.error(i18n.t('notification.export_file_failed'));
          break;
        }
        this.fileIsReady(i18n.t('notification.export_file_ready'), {
          file: {
            url: result.result?.fileName,
            name: fileName,
          },
        });
        break;
      default:
        this.error(i18n.t('notification.export_file_failed'));
        break;
    }
  }
}

export default new NotificationService();
